import type { WearablesContinuityEntry, WearablesRouteSurface } from "./wearables.routeCompanion";
import type { WearablePathTrack } from "./wearables.pathDefaults";
import type { WearablesSessionType, WearablesTimeOfDay } from "./wearablesBehaviorStore";

export type WearablesContext = {
  timeOfDay: WearablesTimeOfDay;
  sessionType: WearablesSessionType;
  recency: number;
};

export function resolveWearablesTimeOfDay(date = new Date()): WearablesTimeOfDay {
  const hour = date.getHours();

  if (hour < 12) {
    return "morning";
  }

  if (hour < 17) {
    return "afternoon";
  }

  if (hour < 21) {
    return "evening";
  }

  return "night";
}

export function resolveWearablesSessionType(args: {
  surface: WearablesRouteSurface;
  track: WearablePathTrack;
}): WearablesSessionType {
  if (args.track === "xr" || args.surface === "xr") {
    return "xr";
  }

  if (args.track === "recovery" || args.track === "readiness") {
    return "recovery";
  }

  if (args.track === "creator" || args.surface === "omnistudio") {
    return "deep";
  }

  return "light";
}

export function getWearablesContext(args: {
  surface: WearablesRouteSurface;
  track: WearablePathTrack;
  continuityEntry?: WearablesContinuityEntry | null;
}): WearablesContext {
  const updatedAt = args.continuityEntry?.updatedAt ? Date.parse(args.continuityEntry.updatedAt) : NaN;

  return {
    timeOfDay: resolveWearablesTimeOfDay(),
    sessionType: resolveWearablesSessionType({
      surface: args.surface,
      track: args.track,
    }),
    recency: Number.isFinite(updatedAt) ? Math.max(Date.now() - updatedAt, 0) : Number.POSITIVE_INFINITY,
  };
}